import { ZustandSsoStore } from './types';

export const getDomainsSelector = (store: ZustandSsoStore) => store.newDomains;

export const getTriggerSelector = (store: ZustandSsoStore) => store.trigger;

export const setDomainsAction = (store: ZustandSsoStore) => store.setDomains;
